import React, { useEffect, useState } from 'react';
import { SriLankaIMG_Slider } from '../../assets/Assets';

function SriLankaImageSlider() {
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setImageIndex((prevIndex) => (prevIndex + 1) % SriLankaIMG_Slider.length);
    }, 5000); // 5 seconds per slide
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='absolute inset-0 w-full h-full bg-gray-900 overflow-hidden'>
      {SriLankaIMG_Slider.map((slide, idx) => (
        <div 
          key={idx}
          className={`absolute inset-0 w-full h-full transition-opacity duration-[2000ms] ease-in-out ${
            idx === imageIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          {/* Low quality placeholder for instant loading */}
          <img
            src={slide.l}
            className="absolute inset-0 w-full h-full object-cover blur-md scale-105"
            alt=""
          />
          {/* High quality main image */}
          <img
            src={slide.h}
            className="absolute inset-0 w-full h-full object-cover"
            alt="Sri Lanka Destination Spotlight"
            loading={idx === 0 ? 'eager' : 'lazy'}
          />
        </div>
      ))}
    </div>
  );
}

export default SriLankaImageSlider;
